import { render } from "./Principal.vue?vue&type=template&id=793fbf62&ts=true"
import script from "./Principal.vue?vue&type=script&lang=ts"
export * from "./Principal.vue?vue&type=script&lang=ts"

import "./Principal.vue?vue&type=style&index=0&id=793fbf62&lang=scss"

import exportComponent from "C:\\Users\\Dell\\latam\\latamlogistichn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__